// Copyright (c) 2024, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { Box, Grid, Typography } from "@mui/material";

interface ErrorHandlerProps {
  message: string | null;
  isFullscreen?: Boolean;
}

const ErrorHandler = ({ isFullscreen, message }: ErrorHandlerProps) => {
  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: isFullscreen ? "100vh" : "calc(100vh - 215px)",
        flexDirection: "column",
        rowGap: 2,
      }}
    >
      <Box>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Grid item xs={12}>
            <img alt="logo" width="160" height="auto" src="/warning.svg"></img>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="inherit"
              sx={{
                color: (theme) =>
                  theme.palette.mode === "light"
                    ? theme.palette.common.black
                    : theme.palette.common.white,
              }}
            >
              {message}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ErrorHandler;
